module.exports = __webpack_public_path__ + "media/packs/site/assets/images/fr/fr_section01_img-c4635180142ac30bb1b0103cb1d04535.png";